import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useUploaders from "my-documents/hooks/use-uploaders/use-uploaders";
import { useMyHrContract, useMyHrEmployee } from "my-hr/hooks";
import { useOcCurrentUserState } from "oc/hooks";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

export const useMyDocumentsUserFilesPage = () => {
  const { contract, employee } = useParams<{
    contract: string;
    employee: string;
  }>();
  const { t, i18n } = useTranslation();
  const isMobile = useOcIsMobile();

  const { data: contractData } = useMyHrContract({ contract });
  const { data: employeeData } = useMyHrEmployee({ employeeId: employee });
  const { data: uploaders = [] } = useUploaders({
    contractCode: contract,
    locale: i18n.language,
  });

  const { employeeCode } = useOcCurrentUserState();

  const isUploader = useMemo(
    () => Array.isArray(uploaders) && uploaders.some((uploader) => uploader.contract === employeeCode),
    [uploaders, employeeCode],
  );

  return useMemo(
    () => ({ t, isMobile, contractData, employeeData, isUploader }),
    [t, isMobile, contractData, employeeData, isUploader],
  );
};

export default useMyDocumentsUserFilesPage;
